"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacyBreakpoints = exports.defaultBreakpointValues = void 0;
// These are the stock Material-UI breakpoint values
exports.defaultBreakpointValues = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
}; // Casting to avoid passing a useless `xxl`
exports.legacyBreakpoints = {
    values: exports.defaultBreakpointValues,
    keys: Object.keys(exports.defaultBreakpointValues),
};
//# sourceMappingURL=legacyBreakpoints.js.map